<div class="text-center mt-5">
  <div class="center_div">
    <div class="container mt-4 text-left">
      <tabset class="member-tabset">
        <tab heading='Informacion de Clasificación'>
          <h4>Nombre</h4>
          <p>{{classification.ClassificationName}}</p>
          <h4>Nivel</h4>
          <p>{{Level.LevelName}}</p>
          <h4>Activo</h4>
          <p>{{classification.Active?'Si':'No'}}</p>
          <h4>orden</h4>
          <p>{{classification.ClassificationOrder}}</p>
        </tab>
        <tab heading='Descipción'>
          <h4>Descripción</h4>
          <p>{{classification.ClassificationDescription}}</p>
        </tab>
      </tabset>
    </div>
    <div class="form-group text-center">
      <button class="btn btn-success" type="button" [routerLink]="['/classifications']">Regresar</button>
    </div>
  </div>
</div>